// extracted by mini-css-extract-plugin
export default {"ReadonlyCommentBoxContainer":"ReadonlyCommentBox-module__ReadonlyCommentBoxContainer--qNC85","centeredContent":"ReadonlyCommentBox-module__centeredContent--bVUCp"};